import { render, staticRenderFns } from "./ExpoChapters.vue?vue&type=template&id=69bb41dc&scoped=true"
import script from "./ExpoChapters.vue?vue&type=script&lang=js"
export * from "./ExpoChapters.vue?vue&type=script&lang=js"
import style0 from "./ExpoChapters.vue?vue&type=style&index=0&id=69bb41dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb41dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69bb41dc')) {
      api.createRecord('69bb41dc', component.options)
    } else {
      api.reload('69bb41dc', component.options)
    }
    module.hot.accept("./ExpoChapters.vue?vue&type=template&id=69bb41dc&scoped=true", function () {
      api.rerender('69bb41dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExpoChapters.vue"
export default component.exports